import { z } from 'zod'

// Scout status enum
export const ScoutStatusEnum = z.enum([
  'new',
  'Aktiv',
  'Inaktiv',
  'On Hold',
  'Partnerschaft beendet (Sonstiges)',
  'Technisches Onboarding',
])
export type ScoutStatus = z.infer<typeof ScoutStatusEnum>

// OSA type enum
export const OsaTypeEnum = z.enum(['isfp', 'marketplace'])
export type OsaType = z.infer<typeof OsaTypeEnum>

export const OSA_TYPE_LABELS: Record<OsaType, string> = {
  isfp: 'iSFP',
  marketplace: 'Marketplace',
}

// Runtime validation with Zod - matches API response
export const ScoutSchema = z.object({
  uuid: z.string(),
  email: z.email(),
  firstName: z.string().min(1).max(100),
  lastName: z.string().min(1).max(100),
  emailVerification: z.boolean(),
  phoneNumber: z.string().optional(),
  city: z.string().optional(),
  street: z.string().optional(),
  postalcode: z.string().optional(),
  status: ScoutStatusEnum.optional(),
  osaTypes: z.array(OsaTypeEnum).optional(),
})

// Derive TypeScript types from schema
export type Scout = z.infer<typeof ScoutSchema>

// API response wrappers
export interface ScoutDetailResponse {
  data: Scout
}

export interface ScoutHistory {
  changedFields: Record<string, unknown>
  changedDate: string
  changedBy: string
}

// DTO types - matches API request structure
export interface CreateScoutDTO {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  city?: string
  street?: string
  postalcode?: string
  osaTypes?: OsaType[]
}

// Update request - matches API structure (id is required)
export interface UpdateScoutDTO {
  id: string // UUID is required for updates
  firstName: string
  lastName: string
  email: string
  phoneNumber?: string // Optional according to API spec
  city?: string
  street?: string
  postalcode?: string
  status?: ScoutStatus
  osaTypes?: OsaType[]
}

// Filter types
export interface ScoutFilters {
  q?: string
  limit?: number
  offset?: number
  page?: number
  search?: string
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  status?: ScoutStatus | ScoutStatus[]
}

export interface ScoutFormProps {
  scout?: Scout
  onSubmit?: (values: CreateScoutDTO | UpdateScoutDTO) => void
  mode?: 'create' | 'edit'
}

// Internal form data structure
export interface ScoutFormData {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  city?: string
  street?: string
  postalCode?: string
  status?: ScoutStatus
  osaTypes?: OsaType[]
}
